/* Какие экраны студии открываются движком шаблона, а какие — родной формой React.
   Список: подмена проверок ?? VITE_ENGINE_SCREENS ?? ENGINE_DEFAULT, пересечённый с ENGINE_READY и реестром ENGINES.
   Сервер может вернуть экран к родной форме без выкладки: me.ui_flags.native_screens.
   Все списки сверяются по каноническим именам (canonicalScreen: circle, lipsync → who; swap → dance) и псевдонимам движков
   (EngineScreen.aliases): экран входа приложения находит движок, который его открывает.
   Решение читается заново при каждом вызове; кадр берёт его один раз, в коммите, который его создаёт, и хранит —
   смена окружения или флага действует со следующего кадра, смонтированный кадр не переключается. */
import { ENGINE_DEFAULT, ENGINE_READY, canonicalScreen, normalizeScreens, parseEngineScreens } from './engine-list';
import { ENGINES, engineEntry } from './engine-host';

/** Строка «voice, circle» или массив имён */
const readScreens = (raw: unknown): string[] | null => typeof raw === 'string' ? parseEngineScreens(raw) : normalizeScreens(raw);
/** Имя движка экрана: ключ ENGINES, который его открывает (с псевдонимами), иначе каноническое имя */
const nameOf = (screen: string) => engineEntry(screen)?.name ?? canonicalScreen(screen);

/** Подмена для проверок шаблона на стенде: только сборка mode test на моках без адреса бэкенда (как запуск MSW, main.tsx).
    В production-сборке условие — константа false, ветка с именем подмены выпадает из бандла
    (scripts/verify-release-artifacts.mjs проверяет, что в static/*.js его нет). */
function qaOverride(): string[] | null {
  if (import.meta.env.MODE === 'test' && import.meta.env.VITE_MOCK_API === 'true' && !import.meta.env.VITE_API_BASE)
    return readScreens((window as unknown as { __steosEngineScreens?: unknown }).__steosEngineScreens);
  return null;
}

/** Экраны, которые сервер велел оставить родными. Флаг необязателен; есть, но не читается как список → все экраны родные. */
function nativeScreens(): string[] | 'all' {
  const flags = (window as unknown as { BotServerMe?: { ui_flags?: { native_screens?: unknown } | null } | null }).BotServerMe?.ui_flags;
  const raw = flags?.native_screens;
  if (raw === undefined || raw === null) return [];
  return readScreens(raw)?.map(nameOf) ?? 'all';
}

/** (подмена проверок ?? VITE_ENGINE_SCREENS ?? ENGINE_DEFAULT) ∩ ENGINE_READY ∩ зарегистрированные ENGINES, канонические имена */
export function engineScreens(): string[] {
  const wanted = qaOverride() ?? parseEngineScreens(import.meta.env.VITE_ENGINE_SCREENS) ?? ENGINE_DEFAULT;
  return [...new Set(wanted.map(nameOf))].filter(screen => ENGINE_READY.includes(screen) && Object.hasOwn(ENGINES, screen));
}

/** Экран открывается движком: он в engineScreens() и сервер не вернул его к родной форме.
    Вызывается один раз, в коммите смены вида, который создаёт кадр. */
export function engineFor(screen: string): boolean {
  const name = nameOf(screen);
  if (!engineScreens().includes(name)) return false;
  const native = nativeScreens();
  return native !== 'all' && !native.includes(name);
}
